import React from 'react';
import { Responsive } from 'react-admin';
import aph_letters from 'assets/aph_letters.png';
// import aph_logo from 'assets/aph_logo.png';

const appTitleStyles = {
  // whiteSpace: 'nowrap',
  overflow: 'hidden',
  WebkitTextOverflow: 'ellipsis',
  textOverflow: 'ellipsis',
  margin: 10,
  letterSpacing: 0
  // fontSize: 24,
  // fontWeight: '400',
  // color: 'rgb(255, 255, 255)',
  // height: 56,
  // lineHeight: '56px'
  // paddingTop: 10,
  // paddingBottom: 10,
  // WebkitFlex: '1 1 0%',
  // MsFlex: '1 1 0%',
  // flex: '1 1 0%',
};

const containerStyle = {
  alignItems: 'center',
  textAlign: 'center',
  display: 'flex'
  // height: 56
};

const imageStyle = { height: 44 };

const AppLogo = props => {
  let { className, children } = props;
  return (
    <span className={className} style={containerStyle}>
      <Responsive
        medium={<img src={aph_letters} style={imageStyle} alt="Apolhygie" />}
      />
      {children && (
        <span className={className} style={appTitleStyles}>
          {children}
        </span>
      )}
    </span>
  );
};

export { AppLogo };



// WEBPACK FOOTER //
// ./src/components/common/AppLogo.js